export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En cours"])},
        "store_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Magasin"])},
        "no_active_challenge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pas de challenge en cours."])},
        "tab_store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivi magasin"])},
        "tab_pilotage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pilotage"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Current"])},
        "store_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store"])},
        "no_active_challenge": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No active challenge."])},
        "tab_store": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Store tracking"])},
        "tab_pilotage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dashboard"])}
      }
    }
  })
}
